import Checkbox from "@material-ui/core/Checkbox";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import { CircularProgress, Tooltip } from "@material-ui/core";
import { Business, Description, VpnKey, Storage, Language, AccountCircle, Lock, Fingerprint, InsertLink, LinkOff } from "@material-ui/icons";
import { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";
import fetchClient from "../../api/fetchClient";

function TabEmpresaIFS({
  values,
  touched,
  errors,
  handleChange,
  setFieldValue,
  onTestConnect,
  onTestConnectHana,
  connected,
  connectedHana,
  isLoading,
  isLoadingHana
}) {
  const [grupos, setGrupos] = useState([]);
  const [subTab, setSubTab] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const fetchGrupos = async () => {
      try {
        const { data } = await fetchClient.get("/ifs/getAllGroups");
        if (!cancelled) setGrupos(data);
      } catch (error) {
        if (!cancelled) console.error("Erro ao buscar grupos:", error);
      }
    };
    fetchGrupos();
    return () => { cancelled = true; };
  }, []);


  return (
    <ModernFormContainer>
      {/* ── Informações Gerais ── */}
      {values.id && (
        <SectionCard>
          <SectionHeader>
            <SectionIcon color="#ff6b35"><Business /></SectionIcon>
            <SectionTitle>Informações Gerais</SectionTitle>
          </SectionHeader>
          <FormGrid columns={3}>
            <StyledFieldContainer>
              <FieldLabel><Fingerprint style={{ fontSize: '18px', marginRight: '8px', color: '#ff6b35' }} />ID</FieldLabel>
              <TextField fullWidth InputLabelProps={{ shrink: true }} disabled id="id" name="id"
                value={values.id} onChange={handleChange} variant="outlined" autoComplete="off" />
            </StyledFieldContainer>

            <StyledFieldContainer>
              <FieldLabel><Business style={{ fontSize: '18px', marginRight: '8px', color: '#ff6b35' }} />Grupo</FieldLabel>
              <TextField select fullWidth id="grupoId" name="grupoId" value={values.grupoId || ""}
                onChange={handleChange} variant="outlined" InputLabelProps={{ shrink: true }}
                error={touched.grupoId && Boolean(errors.grupoId)} helperText={touched.grupoId && errors.grupoId}>
                {grupos.map((g) => (<MenuItem key={g.id} value={g.id}>{g.id}</MenuItem>))}
              </TextField>
            </StyledFieldContainer>

            <FormLabel>
              <Checkbox id="enabled" name="enabled" checked={values.enabled}
                onChange={(e) => handleChange({ target: { name: "enabled", value: e.target.checked } })}
                color="primary" />
              <StatusText active={values.enabled}>{values.enabled ? "✓ Ativo" : "✗ Inativo"}</StatusText>
            </FormLabel>

          </FormGrid>
        </SectionCard>
      )}

      {/* ── Dados da Empresa ── */}
      <SectionCard>
        <SectionHeader>
          <SectionIcon color="#3498db"><Description /></SectionIcon>
          <SectionTitle>Dados da Empresa</SectionTitle>
        </SectionHeader>
        <FormGrid columns={2}>
          <StyledFieldContainer>
            <FieldLabel><Business style={{ fontSize: '18px', marginRight: '8px', color: '#ff6b35' }} />CNPJ</FieldLabel>
            <TextField fullWidth InputLabelProps={{ shrink: true }} id="cnpj" name="cnpj"
              placeholder="00.000.000/0000-00" value={values.cnpj} onChange={handleChange}
              error={touched.cnpj && Boolean(errors.cnpj)} helperText={touched.cnpj && errors.cnpj}
              autoComplete="off" variant="outlined" />
          </StyledFieldContainer>

          <StyledFieldContainer>
            <FieldLabel><Business style={{ fontSize: '18px', marginRight: '8px', color: '#27ae60' }} />Nome da Empresa</FieldLabel>
            <TextField fullWidth InputLabelProps={{ shrink: true }} id="name" name="name"
              placeholder="Nome da empresa" value={values.name} onChange={handleChange}
              error={touched.name && Boolean(errors.name)} helperText={touched.name && errors.name}
              autoComplete="off" variant="outlined" />
          </StyledFieldContainer>

          <StyledFieldContainer fullWidth>
            <FieldLabel><Description style={{ fontSize: '18px', marginRight: '8px', color: '#f39c12' }} />Descrição</FieldLabel>
            <TextField fullWidth InputLabelProps={{ shrink: true }} id="description" name="description"
              placeholder="Descrição detalhada da aplicação" value={values.description} onChange={handleChange}
              error={touched.description && Boolean(errors.description)} helperText={touched.description && errors.description}
              autoComplete="off" variant="outlined" multiline rows={2} />
          </StyledFieldContainer>
        </FormGrid>
      </SectionCard>

      {/* ── Sub-abas SAP / HANA ── */}
      {values.id && (
        <SectionCard noPad>
          <SubTabBar>
            <SubTabBtn type="button" active={subTab === 0} onClick={() => setSubTab(0)}>SAP Business One</SubTabBtn>
            <SubTabBtn type="button" active={subTab === 1} onClick={() => setSubTab(1)}>HANA SQL</SubTabBtn>
          </SubTabBar>

          <SubTabContent>
            {/* ── SAP Business One ── */}
            {subTab === 0 && (
              <>
                <SubSectionHeader>
                  <SectionIcon color="#e74c3c" small><Storage /></SectionIcon>
                  <SubSectionTitle>Conexão SAP</SubSectionTitle>
                  {onTestConnect && (
                    <ConnectionButton onClick={onTestConnect} connected={connected} disabled={isLoading}>
                      {isLoading
                        ? <CircularProgress size={18} style={{ color: 'white' }} />
                        : <Tooltip title={connected ? "Conectado ao SAP" : "Testar conexão SAP"}>
                            {connected ? <InsertLink /> : <LinkOff />}
                          </Tooltip>}
                    </ConnectionButton>
                  )}
                </SubSectionHeader>

                <FormGrid columns={2}>
                  <StyledFieldContainer>
                    <FieldLabel><Storage style={{ fontSize: '18px', marginRight: '8px', color: '#9b59b6' }} />Banco de Dados SAP</FieldLabel>
                    <TextField InputLabelProps={{ shrink: true }} fullWidth id="database" name="database"
                      placeholder="Nome do banco de dados" value={values.database} onChange={handleChange}
                      error={touched.database && Boolean(errors.database)} helperText={touched.database && errors.database}
                      autoComplete="off" variant="outlined" />
                  </StyledFieldContainer>

                  <StyledFieldContainer>
                    <FieldLabel><AccountCircle style={{ fontSize: '18px', marginRight: '8px', color: '#3498db' }} />Login SAP</FieldLabel>
                    <TextField InputLabelProps={{ shrink: true }} fullWidth id="login" name="login"
                      placeholder="Usuário do SAP" value={values.login} onChange={handleChange}
                      error={touched.login && Boolean(errors.login)} helperText={touched.login && errors.login}
                      autoComplete="off" variant="outlined" />
                  </StyledFieldContainer>

                  <StyledFieldContainer>
                    <FieldLabel><Lock style={{ fontSize: '18px', marginRight: '8px', color: '#e74c3c' }} />Senha SAP</FieldLabel>
                    <TextField InputLabelProps={{ shrink: true }} fullWidth id="password" name="password"
                      placeholder="Senha do SAP" type="password" value={values.password} onChange={handleChange}
                      error={touched.password && Boolean(errors.password)} helperText={touched.password && errors.password}
                      autoComplete="off" variant="outlined" />
                  </StyledFieldContainer>

                  <StyledFieldContainer>
                    <FieldLabel><Language style={{ fontSize: '18px', marginRight: '8px', color: '#16a085' }} />URL Service Layer SAP</FieldLabel>
                    <TextField InputLabelProps={{ shrink: true }} fullWidth id="url" name="url"
                      placeholder="https://servicelayer:port/b1s/v1" value={values.url} onChange={handleChange}
                      error={touched.url && Boolean(errors.url)} helperText={touched.url && errors.url}
                      autoComplete="off" variant="outlined" />
                  </StyledFieldContainer>

                </FormGrid>

              </>
            )}

            {/* ── HANA SQL ── */}
            {subTab === 1 && (
              <>
                <SubSectionHeader>
                  <SectionIcon color="#16a085" small><Storage /></SectionIcon>
                  <SubSectionTitle>Conexão HANA SQL</SubSectionTitle>
                  {onTestConnectHana && (
                    <ConnectionButton onClick={onTestConnectHana} connected={connectedHana} disabled={isLoadingHana}>
                      {isLoadingHana
                        ? <CircularProgress size={18} style={{ color: 'white' }} />
                        : <Tooltip title={connectedHana ? "Conectado ao HANA" : "Testar conexão HANA"}>
                            {connectedHana ? <InsertLink /> : <LinkOff />}
                          </Tooltip>}
                    </ConnectionButton>
                  )}
                </SubSectionHeader>

                <FormGrid columns={3}>
                  <StyledFieldContainer>
                    <FieldLabel><Language style={{ fontSize: '18px', marginRight: '8px', color: '#3498db' }} />URL Hana SQL</FieldLabel>
                    <TextField fullWidth InputLabelProps={{ shrink: true }} id="urlHanaSql" name="urlHanaSql"
                      placeholder="https://hana:port" value={values.urlHanaSql} onChange={handleChange}
                      error={touched.urlHanaSql && Boolean(errors.urlHanaSql)} helperText={touched.urlHanaSql && errors.urlHanaSql}
                      autoComplete="off" variant="outlined" />
                  </StyledFieldContainer>

                  <StyledFieldContainer>
                    <FieldLabel><AccountCircle style={{ fontSize: '18px', marginRight: '8px', color: '#9b59b6' }} />Hana UserName</FieldLabel>
                    <TextField fullWidth InputLabelProps={{ shrink: true }} id="hUserName" name="hUserName"
                      placeholder="Usuário Hana" value={values.hUserName} onChange={handleChange}
                      error={touched.hUserName && Boolean(errors.hUserName)} helperText={touched.hUserName && errors.hUserName}
                      autoComplete="off" variant="outlined" />
                  </StyledFieldContainer>

                  <StyledFieldContainer>
                    <FieldLabel><Lock style={{ fontSize: '18px', marginRight: '8px', color: '#e74c3c' }} />Hana Password</FieldLabel>
                    <TextField fullWidth InputLabelProps={{ shrink: true }} id="hPassword" name="hPassword"
                      placeholder="Senha Hana" type="password" value={values.hPassword} onChange={handleChange}
                      error={touched.hPassword && Boolean(errors.hPassword)} helperText={touched.hPassword && errors.hPassword}
                      autoComplete="off" variant="outlined" />
                  </StyledFieldContainer>
                </FormGrid>
              </>
            )}
          </SubTabContent>
        </SectionCard>
      )}

      {/* ── Token de Integração ── */}
      {values.id && (
        <SectionCard>
          <SectionHeader>
            <SectionIcon color="#ff6b35"><VpnKey /></SectionIcon>
            <SectionTitle>Token de Integração</SectionTitle>
          </SectionHeader>
          <StyledFieldContainer>
            <FieldLabel><VpnKey style={{ fontSize: '18px', marginRight: '8px', color: '#ff6b35' }} />Token</FieldLabel>
            <TextField InputLabelProps={{ shrink: true }} fullWidth id="token" name="token"
              placeholder="Token será gerado automaticamente" value={values.token} disabled
              autoComplete="off" variant="outlined" />
          </StyledFieldContainer>
        </SectionCard>
      )}
    </ModernFormContainer>
  );
}

export default TabEmpresaIFS;

// ── Animações ──
const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const ModernFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  font-family: 'Mulish', sans-serif;
`;

const SectionCard = styled.div`
  background: white;
  border-radius: 16px;
  padding: ${props => props.noPad ? '0' : '24px'};
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  border: 1px solid #e8e8e8;
  animation: ${fadeIn} 0.5s ease;
  overflow: hidden;
`;

const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 2px solid #f0f0f0;
`;

const SubTabBar = styled.div`
  display: flex;
  border-bottom: 2px solid #e2e8f0;
  padding: 0 24px;
`;

const SubTabBtn = styled.button`
  background: none;
  border: none;
  border-bottom: 3px solid ${props => props.active ? '#ff6b35' : 'transparent'};
  padding: 14px 20px;
  font-size: 14px;
  font-weight: 600;
  color: ${props => props.active ? '#ff6b35' : '#64748b'};
  cursor: pointer;
  font-family: 'Mulish', sans-serif;
  transition: all 0.2s;
  margin-bottom: -2px;

  &:hover {
    color: #ff6b35;
    background: rgba(255,107,53,0.04);
  }
`;

const SubTabContent = styled.div`
  padding: 24px;
`;

const SubSectionHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 14px;
  border-bottom: 1px solid #f0f0f0;
`;

const SubSectionTitle = styled.h4`
  font-size: 15px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0;
  font-family: 'Mulish', sans-serif;
`;

const ConnectionButton = styled.button`
  margin-left: auto;
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: all 0.3s ease;
  background: ${props => {
    if (props.disabled) return '#e0e0e0';
    return props.connected
      ? 'linear-gradient(135deg, #27ae60 0%, #229954 100%)'
      : 'linear-gradient(135deg, #f39c12 0%, #e67e22 100%)';
  }};
  color: white;
  svg { font-size: 20px; }
`;

const SectionIcon = styled.div`
  width: ${props => props.small ? '32px' : '40px'};
  height: ${props => props.small ? '32px' : '40px'};
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => `${props.color || '#ff6b35'}15`};
  color: ${props => props.color || '#ff6b35'};
  margin-right: 12px;
  svg { font-size: ${props => props.small ? '18px' : '22px'}; }
`;

const SectionTitle = styled.h3`
  font-size: 18px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0;
  font-family: 'Mulish', sans-serif;
`;

const FormGrid = styled.div`
  display: grid;
  grid-template-columns: ${props => props.columns === 3 ? 'repeat(3, 1fr)' : 'repeat(2, 1fr)'};
  gap: 20px;
  @media (max-width: 768px) { grid-template-columns: 1fr; }
`;

const StyledFieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: ${props => props.fullWidth ? '1 / -1' : 'auto'};
  .MuiOutlinedInput-root { border-radius: 10px; }
`;

const FieldLabel = styled.label`
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  font-family: 'Mulish', sans-serif;
`;

const FormLabel = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 0;
  cursor: pointer;
  user-select: none;
`;

const StatusText = styled.span`
  font-size: 15px;
  font-weight: 600;
  color: ${props => props.active ? '#27ae60' : '#7f8c8d'};
  font-family: 'Mulish', sans-serif;
`;

const Divider = styled.hr`
  border: none;
  border-top: 1px solid #f0f0f0;
  margin: 24px 0;
`;

